import styled from 'styled-components';

export const Container = styled.div`
  .input {
    img {
      width: 30px;
    }
  }
  > div {
    width: 620px;

    border-radius: 2.5rem;
  }

  @media (max-width: 1024px) {
    > div {
      width: 100%;
    }
  }
`;
